import { render, staticRenderFns } from "./page-content.vue?vue&type=template&id=7b4807fa"
import script from "./page-content.vue?vue&type=script&lang=js"
export * from "./page-content.vue?vue&type=script&lang=js"
import style0 from "./page-content.vue?vue&type=style&index=0&id=7b4807fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports